var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var defaultTheme = {
    color: {
        background: '#eee',
        primary: '#324ECF',
        secondary: '#ebedfa',
        danger: '#FF3D00',
        accent: '#62727A',
        success: '#4CAF50',
    },
    fontFamily: 'Poppins',
    typography: {
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#333333',
        },
        subHeading: {
            fontSize: '16px',
            fontWeight: '600',
            color: '#333333',
        },
        labels: {
            fontSize: '14px',
            fontWeight: '400',
            color: '#666666',
        },
    },
    card: {
        backgroundColor: '#FFFFFF',
        color: '#6B6B6B',
        fontSize: '14px',
        fontWeight: '400',
        borderColor: '#000000',
        borderWidth: '0px',
        boxShadow: '0px 4px 8px #1A1A1A1A',
        heading: {
            fontSize: '18px',
            fontWeight: '600',
            color: '#111a45',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '500',
            color: '#111a45',
        },
    },
};
export var defaultKanbanTheme = __assign(__assign({}, defaultTheme), { column: {
        backgroundColor: '#E1E1E1',
        color: '#6B6B6B',
        fontSize: '14px',
        fontWeight: '400',
        borderColor: '#000000',
        borderWidth: '0px',
        boxShadow: '8px 4px 8px #BABABA',
        heading: {
            fontSize: '14px',
            fontWeight: '600',
            color: '#111a45',
            backgroundColor: '#D6D6D6',
        },
        subHeading: {
            fontSize: '14px',
            fontWeight: '600',
            color: '#111a45',
            backgroundColor: '#D6D6D6',
        },
    } });
